//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    var gap = 0;
    var gapData = parseInt($(this).attr('data-sc-gap'));
    if(gapData) gap = gapData;

    position += gap;

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function() {
  $('.products-kv__sc').each(function(index, el) {
    const sc = $(this);
    const kv = $('.products-kv');

    $(window).on('scroll resize', function(event) {
      run();
    });

    setInterval(function(){
      run();
    }, 100);

    function run() {
      let wT = $(window).scrollTop();
      let wH = $(window).innerHeight();
      let wB = wT + wH;
      let kvT = kv.offset().top;
      let kvH = kv.innerHeight();
      let kvB = kvT + kvH;

      let gap = 0;
      if($('.u-sp').css('display') != 'none') {
        gap -= 60;
      }

      if(kvB > wB + gap) {
        sc.addClass('is-fix');
      } else {
        sc.removeClass('is-fix');
      }
    }
  });
});

/*$(function() {
  const $sec = $('.createit-sec');

  if($sec[0]) {
    const $scBtn = $('.js-createit-pagettl__sc');
    const $dots = $('.createit-concept__dots');
    const $dotsBtn = $('.createit-concept__dots i');

    $sec.attr('data-cr', '0');

    setTimeout(function(){
    $("html, body").animate({scrollTop:0}, 0, "swing");

      $.scrollify({
        section : ".createit-sec",
        sectionName : "section-name",
        interstitialSection : "",
        easing: "swing",
        scrollSpeed: 300,
        offset : 0,
        scrollbars: true,
        standardScrollElements: "",
        setHeights: true,
        overflowScroll: true,
        updateHash: false,
        touchScroll:true,
        before:function(index) {
          $sec.attr('data-cr', index);
          $dots.attr('data-cr', index);
        },
        after:function() {},
        afterResize:function() {},
        afterRender:function() {}
      });
    }, 200);

    $scBtn.on('click', function(event) {
      $.scrollify.move("#concept1");
    });

    $dotsBtn.on('click', function(event) {
      let index = $dotsBtn.index(this);

      $.scrollify.move("#concept" + (index + 1));
    });
  }
});*/

//fade
$(function(){
  var fade = $('.fade');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 500);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.createit-pagettl').each(function(index, el) {
    const $sec = $(this);
    const $wrap = $('.createit-pagettlWrap');
    const $sliderWrap = $('.createit-secSliderWrap');

    $(window).on('scroll resize', function(event) {
      run();
    });

    run();

    function run() {
      let wT = $(window).scrollTop();
      let wH = $(window).innerHeight();
      let wB = wT + wH;
      let kvT = $wrap.offset().top;
      let kvH = $wrap.innerHeight();
      let kvB = kvT + kvH;

      let wrapH = $wrap.innerHeight();

      if(kvB < wB) {
        $wrap.css('height', wrapH);
        $sec.addClass('is-fix');
      } else {
        $wrap.removeAttr('style');
        $sec.removeClass('is-fix');
      }

      if(kvB < wT || $('.u-sp').css('display') != 'none') {
        $wrap.removeAttr('style');
        $sec.removeClass('is-fix');
      }

      if($sliderWrap.offset().top < wT + 60) {
        $sliderWrap.addClass('is-bgWt');
      } else {
        $sliderWrap.removeClass('is-bgWt');
      }
    }
  });
});

/*$(function(){
  $('.createit-secSlick').each(function(index, el) {
    const $root = $(this);
    const $slider = $(this);

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    });

    $slider.on('afterChange', function(event, slick, currentSlide){
      $root.find('.createit-concept').removeClass('is-fade fade');
      $root.find('.slick-active .createit-concept').addClass('is-fade');
    });

    $slider.slick({
      dots: true,
      swipe: false,
      fade: true,
      arrows: false
    });
  });*/

$(function(){
  $('.createit-secSlick').each(function(index, el) {
    const $slider = $(this);
    const $slide = $slider.find('.createit-secSlickSlide');
    const $dots = $('.createit-concept__dots');
    const $dotsBtn = $('.createit-concept__dots i');

    $(window).on('scroll resize', function(event) {
      run();
    });

    run();

    $dotsBtn.on('click', function(event) {
      let index = $dotsBtn.index(this);
      let y = $slide.eq(index).offset().top + 50;

      $dots.attr('data-cr', index + 1);
      $("html, body").animate({scrollTop:y}, 500, "swing");
    });

    function run(n = -1) {
      let wT = $(window).scrollTop();
      let wH = $(window).innerHeight();
      let wB = wT + wH;
      let wC = (wT + wB) / 2;
      let nowOld = -1;
      let now = -1;

      $slide.each(function(index, el) {
        const t = $(this);
        const over = t.find('.createit-conceptOver');
        const sec = t.find('.createit-sec');

        let tT = t.offset().top;
        let tH = t.innerHeight();
        let tB = tT + tH;
        let tC = (tT + tB) / 2;

        if(wC > tC) {
          nowOld = now;
          now = index;
        }

/*        if(wC > tB + 500) {
          sec.addClass('is-hide');
        } else {
          sec.removeClass('is-hide');
        }*/

/*        if(wB > tC - 500) {
          over.addClass('is-show');
        } else {
          over.removeClass('is-show');
        }*/
      });

      if(!(nowOld && index)) {
        $slide.find('.createit-sec').removeClass('is-fade');

        if(now > -1) {
          $dots.attr('data-cr', now + 1);
          $slide.eq(now).find('.createit-sec').addClass('is-fade');
          $dots.addClass('is-show');
        } else {
          $dots.attr('data-cr', '');
          $dots.removeClass('is-show');
        }
      }
    }
  });
});

$(function(){
  const $root = $('.body-spTouchArea');

  if($root[0]) {
    $(window).bind("touchstart", onTouchStart);
    $(window).bind("touchmove", onTouchMove);
    $(window).bind("touchend", onTouchEnd);

    const $html = $('html');

    const $footer = $('footer');
//    $footer.addClass('js-spSec is-innerSec');

    const $body = $('.createit-body');
    $body.append('<style>@media screen and (max-width: 768px) { html { overflow: hidden; } }</style>')
    const $sec = $('.js-spSec');
    const $pagettlSc = $('.js-createit-pagettl__scSP');
    const $txtOver = $('.createit-concept__spTxtOver');
    const $txtTri = $('.createit-concept__spTxtTri');
    const $dots = $('.createit-concept__spDots');
    let now = 0;
    let innerSc = false;
    let innerScT = -1;
    let innerScB = -1;
    let bodyT = -1;

    let direction, position, move;


    $pagettlSc.on('click', function(event) {
      now = 2;
      moveSec();
    });

    $dots.find('i').on('click', function(event) {
      let index = $dots.find('i').index(this);

      now = Math.ceil(index * 2) + 2;
      moveSec('', 'dots');
    });

    function getPosition(event) {
      return event.originalEvent.touches[0].pageY;
    }

    function onTouchStart(event) {
      if($('.u-pc').css('display') != 'none') {
        return false;
      }

      move = 0;
      position = getPosition(event);

      bodyT = parseInt($body.css('top'));
    }

    function onTouchMove(event) {
      if($('.u-pc').css('display') != 'none') {
        return false;
      }

      move = position - getPosition(event);
      direction = (position > getPosition(event)) ? "bottom" : "top";
      event.preventDefault();

      //インナースクロール動作
      if(innerSc) {
        let y = bodyT - move * 1.4;

        if(y > innerScT) {
          y = innerScT;
        }

        if(y < innerScB) {
          y = innerScB;
        }

        $body.css({
          top: y
        });
      }
    }

    function onTouchEnd(event) {
      if($('.u-pc').css('display') != 'none') {
        return false;
      }

      if(move > 10 || move < -10) {
        moveSec(direction);
      }
    }

    function moveSec(d = '', type = '') {
      if(d == 'bottom') {
        if(innerSc) return false;

        now ++;

        if(now > $sec.length - 1) {
          now = $sec.length - 1;
          return false;
        }
      } else if(d == 'top') {
        if(innerSc) {
          let gap = bodyT - innerScT;
          if(gap > -10 && gap < 10) {
            innerSc = false;
          }
        }

        if(innerSc) return false;

        now --;

        if(now < 0) {
          now = 0;
          return false;
        }

//        $footer.scrollTop(0);
      }

      //ドットと三角とテキストオーバー
      let conceptNow = now - 2;

      if(now >= 2 && now <= 13) {
        $txtOver.addClass('is-show');

        if(conceptNow % 2 == 1) {
          $txtOver.removeClass('is-show');
        }

        if((d == 'bottom' && conceptNow % 2 == 0) ||
           (d == 'top' && conceptNow % 2 == 1) ||
           (type == 'dots')) {
          $txtTri.removeClass('is-show');

          setTimeout(function(){
            $txtTri.addClass('is-show');
          }, 400);
        } else {
          $txtTri.addClass('is-show');
        }

        $dots.addClass('is-show');
        $dots.attr('data-cr', Math.ceil((conceptNow + 1) / 2));
      } else {
        $txtOver.removeClass('is-show');
        $txtTri.removeClass('is-show');
        $dots.removeClass('is-show');
      }

      //スクロール
      let $tarSec = $sec.eq(now);

      if($tarSec[0]) {
        let y = ($body.offset().top - $sec.eq(now).offset().top);

        $body.css({
          top: y
        }).attr('data-now', now);

        if($tarSec.hasClass('js-spSecFade')) {
          $tarSec.addClass('is-fade');
        }

        //Videosはインナースクロールをする
        if($tarSec.hasClass('createit-videos')) {
          innerSc = true;
          innerScT = y;
          innerScB = y - $tarSec.innerHeight() - $footer.innerHeight() - 60 + $(window).innerHeight();
          $body.css('transition-duration', '.2s');
        } else {
          innerSc = false;
          innerScT = -1;
          innerScB = -1;
          $body.css('transition-duration', '.5s');
        }
      }
    }
  }
});

$(function(){
  const $img = $('.oral-fea__prodImg p');

  if($img[0]) {
    const $thumb = $('.oral-fea__thumbs p');

    $thumb.each(function(index, el) {
      const $t = $(this);
      const $i = index;

      $t.on('click', function(event) {
        $thumb.removeClass('is-cr');
        $t.addClass('is-cr');

        $img.removeClass('is-cr');
        $img.eq($i).addClass('is-cr');
      });
    });
  }
});


$(function(){
  const $con = $('.oral-other__con');

  if($con[0]) {
    const $btn = $('.oral-other__nav a');
    const $btnSP = $('.oral-other__navSP a');
    const $backSP = $('.oral-other__conBackSP a');
    const $conWrap = $('.oral-other__conWrap');

    $btn.each(function(index, el) {
      const $t = $(this);
      const $i = index;

      $t.on('click', function(event) {
        $btn.removeClass('is-cr');
        $t.addClass('is-cr');

        $con.stop().hide().eq($i).fadeIn();
      });
    });

    $btnSP.each(function(index, el) {
      const $t = $(this);
      const $i = index;

      $t.on('click', function(event) {
        $btnSP.removeClass('is-cr');
        $t.addClass('is-cr');

        $con.stop().hide().eq($i).fadeIn();

        if($(window).scrollTop() > $conWrap.offset().top) {
          let y = $conWrap.offset().top;
          $("html, body").animate({scrollTop:y}, 100, "swing");
        }
      });
    });

    $backSP.each(function(index, el) {
      const $t = $(this);
      const $i = index;

      $t.on('click', function(event) {
        $btnSP.removeClass('is-cr');

        $con.stop().hide();
      });
    });

    if($('.u-pc').css('display') != 'none') {
      $btn.eq(0).addClass('is-cr');
      $con.eq(0).fadeIn();
    }
  }
});


$(function(){
  const $slider = $('.oral-kv__slick');

  if($slider[0]) {
    $slider.slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnActive: false
    });
  }
});

$(function(){
  const $slider = $('.products-storySlick');

  if($slider[0]) {
    $slider.slick({
      variableWidth: true,
      centerMode: true
    });
  }
});

